import keygen from "./genkey.js";

export default {
  samtala: {
    rough: {
      title: "",
      text: "",
      extracontent: [],
      options: [
        {
          label: "",
          value: ""
        },
        {
          label: "",
          value: ""
        },
        {
          label: "",
          value: ""
        }
      ]
    },
    a1: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        content: {
          list: [""]
        },
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ],
    a2: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ],
    b1: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ],
    b2: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ],
    c1: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ],
    c2: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ]
  },
  beratta: {
    rough: {
      extracontent: [],
      title: "",
      text: "",
      options: [
        {
          label: "",
          value: ""
        },
        {
          label: "",
          value: ""
        },
        {
          label: "",
          value: ""
        }
      ]
    },
    a1: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ],
    a2: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ],
    b1: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ],
    b2: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ],
    c1: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ],
    c2: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ]
  },
  lyssna: {
    rough: {
      extracontent: [],
      title: "",
      text: "",
      options: [
        {
          label: "",
          value: ""
        },
        {
          label: "",
          value: ""
        },
        {
          label: "",
          value: ""
        }
      ]
    },
    a1: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ],
    a2: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ],
    b1: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ],
    b2: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ],
    c1: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ],
    c2: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ]
  },
  skriva: {
    rough: {
      extracontent: [],
      title: "",
      text: "",
      options: [
        {
          label: "",
          value: ""
        },
        {
          label: "",
          value: ""
        },
        {
          label: "",
          value: ""
        }
      ]
    },
    a1: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ],
    a2: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ],
    b1: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ],
    b2: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ],
    c1: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ],
    c2: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ]
  },
  lasa: {
    rough: {
      extracontent: [],
      title: "",
      text: "",
      options: [
        {
          label: "",
          value: ""
        },
        {
          label: "",
          value: ""
        },
        {
          label: "",
          value: ""
        }
      ]
    },
    a1: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ],
    a2: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ],
    b1: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ],
    b2: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ],
    c1: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ],
    c2: [
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      },
      {
        uid: keygen(),
        title: "",
        description: "",
        extracontent: [],
        options: [
          {
            label: "",
            value: ""
          },
          {
            label: "",
            value: ""
          }
        ]
      }
    ]
  }
};
